module.exports = __webpack_public_path__ + "static/media/llanta-inspeccion-green.54714d09.svg";